"use client";
import { Popover, PopoverProps } from "@mui/material";
import React, { ReactNode, useCallback, useState } from "react";
import FmButton, { IButtonProps } from "../FmButton";
import stl from "../../styles/popover.module.scss";
import classnames from "classnames";
interface IProps extends Omit<PopoverProps, "open"> {
    button: ReactNode;
    buttonProps?: IButtonProps;
}
const FmPopover: React.FC<IProps> = (props) => {
    const { buttonProps, ...rest } = props;
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const handleTogglePopover = useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl((prev) => (prev ? null : event.currentTarget));
        },
        [],
    );
    return (
        <>
            <FmButton
                id={"simle-poppover"}
                onClick={handleTogglePopover}
                {...buttonProps}
                className={classnames(
                    buttonProps?.classes?.root,
                    buttonProps?.className,
                    { [stl["button-arrow"]]: anchorEl },
                )}
            >
                {props.button}
            </FmButton>
            <Popover
                {...rest}
                id={"simle-poppover"}
                open={!!anchorEl}
                anchorEl={anchorEl}
                anchorOrigin={
                    props.anchorOrigin ?? {
                        vertical: "bottom",
                        horizontal: "center",
                    }
                }
                transformOrigin={
                    props.transformOrigin ?? {
                        vertical: "top",
                        horizontal: "center",
                    }
                }
                onClose={handleTogglePopover}
                classes={{
                    paper: stl["root"],
                }}
            >
                {props.children}
            </Popover>
        </>
    );
};

export default FmPopover;
